import NotificationResolvedUserAvatar from '@/app/core/components/notification/NotificationResolvedUserAvatar'

export default function NotificationaUserAvatars({
  involvedUsers,
}: {
  involvedUsers: string[]
}) {
  return (
    <div className='tw-flex tw-flex-col tw-basis-10 tw-shrink-0 tw-grow-0'>
      {involvedUsers.length === 1 && (
        <NotificationResolvedUserAvatar
          userId={involvedUsers[0]}
          color='blue'
        />
      )}
      {involvedUsers.length === 2 && (
        <>
          <NotificationResolvedUserAvatar
            userId={involvedUsers[0]}
            className='-tw-translate-x-3'
            size='xs'
            color='green'
          />
          <NotificationResolvedUserAvatar
            userId={involvedUsers[1]}
            className='-tw-translate-y-2 tw-translate-x-0.5'
            size='xs'
            color='blue'
          />
        </>
      )}
      {involvedUsers.length > 2 && (
        <>
          <NotificationResolvedUserAvatar
            userId={involvedUsers[0]}
            className='-tw-translate-x-3'
            size='xs'
            color='green'
          />
          <div className='tw-w-6 tw-h-6 tw-rounded-full tw-bg-neutral-100 tw-flex tw-justify-center tw-items-center -tw-translate-y-2 tw-translate-x-2.5'>
            <span className='tw-text-2xs'>{`+${involvedUsers.length - 1}`}</span>
          </div>
        </>
      )}
    </div>
  )
}
